import { toBase64, fromBase64 } from '@jsonjoy.com/base64';

// Ported verbatim from web/src/utils/base64.ts so server-side markdown rendering
// produces byte-identical base64-encoded attributes (must round-trip with the
// deserializer, which decodes the same encoding).
export function encodeBase64(value: string) {
  return toBase64(new TextEncoder().encode(value));
}

export function decodeBase64(value: string) {
  return String.fromCharCode(...fromBase64(value));
}
